import { render, staticRenderFns } from "./deactivated-empty-state.vue?vue&type=template&id=703d448e&"
import script from "./deactivated-empty-state.vue?vue&type=script&lang=js&"
export * from "./deactivated-empty-state.vue?vue&type=script&lang=js&"
import style0 from "./deactivated-empty-state.vue?vue&type=style&index=0&id=703d448e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports